import { handleApiError } from './api-error-handler'

/**
 * Generic API call wrapper for handling async thunk rejections
 * Now includes automatic token refresh and cross-tab coordination
 */
export const apiCall = async <T, TArgs extends unknown[]>(
  apiFunction: (...args: TArgs) => Promise<T>,
  // RTK rejectWithValue payloads vary per thunk — deliberate `any` at this boundary.
  rejectWithValue: (value: any) => unknown,
  ...args: TArgs
): Promise<T> => {
  try {
    return await apiFunction(...args)
  } catch (error) {
    try {
      const result = await handleApiError(error, apiFunction, args, rejectWithValue)
      return result
    } catch (handledError) {
      // If error handler also fails, return the handled error
      return handledError as T
    }
  }
}
